import { Directive, HostListener, output } from '@angular/core';
import { APPCONSTANT } from '../constants';

@Directive({
  selector: '[ammScrollDirection]',
  standalone: true,
})
export class ScrollDirectionDirective {
  public isMobileWebSize = output<boolean>();
  public scrollDirection = output<string>();
  public scrollEvent = output<boolean>();

  private lastScrollPosition: number = 0;

  @HostListener('document:scrollend', ['$event'])
  private onScroll(event: Event) {
    if (this.lastScrollPosition < window.scrollY) {
      this.scrollDirection.emit('Down');
      this.lastScrollPosition = window.scrollY;
    } else {
      this.scrollDirection.emit('Up');
      this.lastScrollPosition = window.scrollY;
    }

  }
  
  @HostListener('document:scroll', ['$event'])
  private onScrollMove(event: Event) {
    const scrollPosition = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    
    const aroundEnd: boolean = (scrollPosition + clientHeight) >= (scrollHeight - APPCONSTANT.THRESHOLD);

    this.scrollEvent.emit(aroundEnd);
  }
  

  @HostListener('window:resize', [])
  private onResize(): void {
    this.isMobileWebSize.emit(window.innerWidth <= APPCONSTANT.SMALL_SIZE_WIDTH);
  }
}